require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-will-idbs-new-environmental-social-policies-protect.json") })
        }
      }, "path---en-us-update-will-idbs-new-environmental-social-policies-protect");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-will-idbs-new-environmental-social-policies-protect!./.cache/json/en-us-update-will-idbs-new-environmental-social-policies-protect.json
// module id = 869
// module chunks = 231608221292675